import { mapMutations } from "vuex";
import axios from "axios";

export const navigatonFunctions = {
  data() {
    return {
      routerPaths: [],
      prevRoute: "",
      nextRoute: "",
      currPathID: "",
      prevPathID: "",
    };
  },
  created() {
    let routeChilds = this.$router.options.routes[1].children;
    [...routeChilds].forEach((el) => {
      if (el.props != undefined) {
        this.routerPaths.push({
          id: el.props.id,
          path: el.path,
        });
      }
    });
  },
  watch: {
    $route: function (to, from) {
      let _index = from.path != "/" ? 1 : 0;
      let index = to.path != "/" ? 1 : 0;
      let idFrom = from.matched[_index].props.default.id;
      let id = to.matched[index].props.default.id;
      let nextR = this.routerPaths.find((el) => el.id == id + 1);
      let prevR = this.routerPaths.find((el) => el.id == idFrom);

      let prevPath = this.routerPaths.find((el) => el.id == id - 1);

      this.nextRoute = nextR != undefined ? nextR.path : "";
      this.currPathID = nextR != undefined ? nextR.id - 1 : "";

      this.prevRoute = prevPath != undefined ? prevPath.path : "";
      this.prevPathID = prevR != undefined ? prevR.id : "";
      this.updateNav([id, idFrom]);

      this.closeModals({
        openModal: false,
      });

      if (process.env.NODE_ENV === "production") {
        if (
          (to.name === "DesignInterior" && from.name !== "Resume") ||
          to.name === "Resume"
        ) {
          this.submitForm();
        }
      }
    },
  },
  methods: {
    ...mapMutations({
      updateNav: "navbarState/UPDATE_CURR_ACTIVE",
      closeModals: "modalData/UPDATE_MODALSTATE",
    }),
    submitForm() {
      let serializeToObj = (form) => {
        if (!form || form.nodeName !== "FORM") return;
        let i,
          q = {};
        for (i = form.elements.length - 1; i >= 0; i = i - 1) {
          if (form.elements[i].name === "") continue;

          let key = form.elements[i].name;
          let val = form.elements[i].value;
          q[key] = val;
        }
        return q;
      };

      let el = document.getElementById("cfgHyuSubmitForm");
      let payload = JSON.stringify(serializeToObj(el));

      const hyu = process.env.VUE_APP_HYU;
      let url = hyu + process.env.VUE_APP_API_FORMOBJ;
      axios.post(url, payload).then(() => "Fail submit config");
    },
  },
};
